import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `NetworksControllerStateProvider` not mounted on RN.
export default function useNetworksControllerState(): any {
  const { state } = useController('NetworksController' as any)
  return state as any
}
